import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="logo">Conduit</div>
            <p>Creating efficient drip irrigation technology for farmers worldwide.</p>
          </div>
          <div className="footer-section">
            <h4>Pilot</h4>
            <a href="#pilot">Join our Pilot</a>
            <a href="#pilot">Get Started</a>
          </div>
          <div className="footer-section">
            <h4>Product</h4>
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Conduit. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
